(function($) {
    $(document).ready(function() {
      $('.navbar-toggler').on('click', function() {
        $('.mobile-nav').toggleClass('isOpen');
      });
    });
  })(jQuery);
  